module.exports = __webpack_public_path__ + "static/media/BlackLady.95f3cc2b.jpg";